module.exports = __webpack_public_path__ + "static/media/hn.c94622ad.svg";